import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FaStar } from "react-icons/fa";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from "reactstrap";

import ProfileCard from "@components/Booking/ProfileCard/ProfileCard";
import { FavouriteListProp } from "@models/shared/shared.model";
import commonUtils from "@utils/common.utils";

const Favourite = ({
  favouriteEvents,
  removeUserFavourites,
  selectedGuestList,
  userFavouriteList,
}: FavouriteListProp) => {
  const { t } = useTranslation();

  const [isOpen, setIsOpen] = useState<boolean>(true);

  const toggle = () => {
    setIsOpen(prev => !prev);
  };

  return (
    <div className="mt-3 fg-favourite-accordion-wrapper">
      <Accordion open={isOpen ? "fg-favourite-accordion" : ""} toggle={toggle}>
        <AccordionItem>
          <AccordionHeader targetId="fg-favourite-accordion">
            <FaStar className="me-2" fill="var(--warning-light)" />{" "}
            {t("favourites")} ({userFavouriteList.length})
          </AccordionHeader>

          <AccordionBody accordionId="fg-favourite-accordion">
            <div className="d-flex gap-3 flex-wrap">
              {userFavouriteList.map(guest => {
                const isAlreadySelected = selectedGuestList.some(
                  selected => selected.profileUuid === guest.profileUuid
                );
                const label = commonUtils.getCardNameByType(guest);
                const params = {
                  ...guest,
                  label: label,
                  value: guest.profileUuid,
                };
                return (
                  <ProfileCard
                    key={guest.profileUuid}
                    cardId={guest.profileUuid}
                    handleRemoveCard={() => {
                      removeUserFavourites(guest.profileUuid);
                    }}
                    cardName={label}
                    favouriteEvents={() => favouriteEvents(params)}
                    disabled={isAlreadySelected}
                  />
                );
              })}
            </div>
          </AccordionBody>
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default Favourite;
